import { render, staticRenderFns } from "./KakaoLogin.vue?vue&type=template&id=60b61c2f&scoped=true&"
import script from "./KakaoLogin.vue?vue&type=script&lang=js&"
export * from "./KakaoLogin.vue?vue&type=script&lang=js&"
import style0 from "./KakaoLogin.vue?vue&type=style&index=0&id=60b61c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b61c2f",
  null
  
)

export default component.exports